import { Badge } from "../../components/ui/badge";
import {
  Card,
  CardContent,
  CardHeader,
} from "../../components/ui/card";
import { Progress } from "../../components/ui/progress";
import { CheckCircle2, RefreshCcw, Clock, AlertCircle } from "lucide-react";
import type { EnrichmentJob } from "wasp/entities";
import { formatDate } from "../../admin/dashboards/enrichmentViewer/utils";
import { useTranslation } from "../../i18n/hooks";

const getStatusIcon = (status: string) => {
  switch (status) {
    case "completed":
      return <CheckCircle2 className="w-5 h-5 text-green-500" />;
    case "in_progress":
      return <RefreshCcw className="w-5 h-5 text-blue-500 animate-spin" />;
    case "queued":
      return <Clock className="w-5 h-5 text-gray-500" />;
    default:
      return null;
  }
};

const getStatusColor = (status: string) => {
  switch (status) {
    case "completed":
      return "bg-green-100 text-green-800";
    case "in_progress":
      return "bg-blue-100 text-blue-800";
    case "queued":
      return "bg-gray-100 text-gray-800";
    default:
      return "";
  }
};

const JobFailedCard = ({ job }: { job: EnrichmentJob }) => {
  const { t } = useTranslation();
  
  return (
    <Card className="w-full">
      <CardHeader className="flex flex-row items-center justify-between">
        <div className="flex items-center space-x-4">
          {getStatusIcon(job.status)}
          {/* <CardTitle className="text-xl">{job.name}</CardTitle> */}
          <Badge className={`${getStatusColor(job.status)} capitalize`}>
            {job.status?.replace("_", " ")}
          </Badge>
        </div>
        <span className="text-sm text-gray-500">
          {formatDate(job.createdAt)}
        </span>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {/* Progress Overview */}
          {/* Error Overview */}
          <div className="bg-red-50 p-6 rounded-lg">
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center gap-2">
                <AlertCircle className="h-5 w-5 text-red-600" />
                <h3 className="text-lg font-semibold text-red-900">
                  {t('jobsView.job_failed')}
                </h3>
              </div>
            </div>
            <Progress
              value={job.progress}
              className="h-2 bg-red-100"
            />
            
            <div className="mt-4 p-4 bg-red-100 rounded border border-red-200">
              <p className="text-sm text-red-800">
                {job.failReason || t('jobsView.unknown_error')}
              </p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default JobFailedCard;
